import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Breadcrumb } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import Typography from '@material-ui/core/Typography';
import PropTypes from 'prop-types';

const styles = () => ({
  crumbIconItem: {
    display: 'inline',
  },
  activeItem: {
    fontWeight: 'bold',
  },
})

const CrumbIconItem = ({
  classes,
  to,
  children,
  active,
  ...props
}) => (
  <LinkContainer to={to}>
    <Breadcrumb.Item {...props} className={classes.crumbIconItem}>
      <Typography variant="body2" className={`${classes.crumbIconItem}${active ? ` ${classes.activeItem}` : ''}`}>
        {children}
      </Typography>
    </Breadcrumb.Item>
  </LinkContainer>
);

CrumbIconItem.propTypes = {
  classes: PropTypes.object.isRequired,
  to: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  active: PropTypes.bool,
}

CrumbIconItem.defaultProps = {
  children: null,
  active: false,
}

export default withStyles(styles)(CrumbIconItem);
